import React from 'react';
import Select from 'react-select';

export const styles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: '3px',
        minHeight: '40px',
        border: state.isSelected
            ? '1px solid var(--input-border-color-active)'
            : state.isFocused
                ? '1px solid var(--input-border-color-active)'
                : '1px solid var(--input-border-color)',
        boxShadow: state.isFocused
            ? '0 0 5px #cacaca'
            : 'inset 0 1px 2px rgb(10 10 10 / 10%)',
        backgroundColor: state.isDisabled
            ? 'var(--input-background-disabled)'
            : 'white',
        cursor: state.isDisabled
            ? 'not-allowed'
            : 'pointer',
        pointerEvents: 'auto',
    }),
    input: (provided, state) => ({
        ...provided,
        visibility: 'visible !important', // For some reason, the component is hiding the input when it's disabled. This hack makes it visible again
        color: state.isDisabled
            ? 'var(--input-disabled-text-color)'
            : 'var(----siteconfig-ui-std-txtcolor-rgba)',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--siteconfig-ui-btn-stdcolor)',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 50,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 50,
    })
}

export const theme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary: '#797979',
        primary75: '#ababab',
        primary50: '#cdcdcd',
        primary25: '#ececec',
    }
})

const SelectInput = (props) => {

    /*
     * React select needs the value to be an object with both the label and
     * value, so this just builds and returns that based on the single value
     * prop and the corresponding label in the options.
     * If props.value is already an object it just uses that
     */
    const getReactSelectValueObject = (option) => {
        if ((!props.isMulti && typeof props.value === 'object')
            || (props.isMulti && !Array.isArray(props.value))
        ) {
            return props.value;
        }

        let value = props.value;
        let label = null;
        let selected = [];

        for (let i in props.options) {
            if (!props.options.hasOwnProperty(i)) {
                continue;
            }

            if (props.isMulti) {
                if (Array.isArray(value) && value.includes(props.options[i].value)) {
                    selected.push(props.options[i]);
                }
            } else {
                if (props.options[i].value === value) {
                    label = props.options[i].label
                    break;
                }
            }
        }

        if (props.isMulti) {
            return selected;
        } else {
            return {
                value: value,
                label: label
            }
        }
    }

    const handleChange = (option) => {
        if (props.onChange) {
            let value;

            if (props.isMulti) {
                value = (option ? option.map(o => o.value) : null);
            } else {
                value = (option ? option.value : null);
            }

            const fakeEvent = {
                target: {
                    name: props.name,
                    value,
                }
            }
            props.onChange(fakeEvent);
        }
    }

    return (
        <Select
            name={props.name}
            className={`react-select-container ${props.className}`}
            classNamePrefix={props.classNamePrefix}
            placeholder={(props.placeholder) ? props.placeholder : <div>Please select</div>}
            value={getReactSelectValueObject()}
            onChange={(option) => handleChange(option)}
            required={props.required ?? false}
            options={props.options}
            theme={theme}
            styles={styles}
            isClearable={props.isClearable}
            menuPortalTarget={props.menuPortalTarget}
            maxMenuHeight={props.maxMenuHeight}
            isMulti={props.isMulti}
            isDisabled={props.disabled}
        />
    )
}

SelectInput.defaultProps = {
    isClearable: false,
    classNamePrefix: '',
    menuPortalTarget: null,
    isMulti: false,
    disabled: false,
    maxMenuHeight: 300,
}

export default SelectInput;
